import _defineProperty from "@babel/runtime/helpers/defineProperty";
/**
 * Singleton service that manages dedup state for Gate BI events (1052/1053/1054).
 *
 * Why a singleton instead of useRef?
 * The Gate component unmounts when the user clicks "Get It" and remounts on
 * browser-back.  useRef would reset on remount, causing duplicate events.
 * This service persists across the unmount/remount cycle within the SPA.
 *
 * Call `gateBiDedupService.reset()` in test afterEach() to prevent inter-test leakage.
 */
class GateBiDedupService {
  constructor() {
    _defineProperty(this, "_lastFiredSearchTerm", void 0);
    _defineProperty(this, "_lastFired1053Term", void 0);
    _defineProperty(this, "_lastFired1054Term", void 0);
    _defineProperty(this, "_lastFired506Key", void 0);
  }
  shouldFire1052(searchTerm) {
    if (!searchTerm || searchTerm === this._lastFiredSearchTerm) {
      return false;
    }
    this._lastFiredSearchTerm = searchTerm;
    return true;
  }
  shouldFire1053(searchTerm) {
    if (!searchTerm || searchTerm === this._lastFired1053Term) {
      return false;
    }
    this._lastFired1053Term = searchTerm;
    return true;
  }

  // Only lock the term after a non-empty payload is about to be reported.
  // onResultsPageLoad can fire with type:'suggestions' before the list has
  // populated (empty array); locking on that first empty call would block the
  // real, non-empty re-fire for the same term and drop 1054 entirely.
  // An empty search term is a valid firing (default suggestions shown on
  // page load, reported with search_term NULL) — deduped under the '' key.
  shouldFire1054(searchTerm, suggestionsCount) {
    if (suggestionsCount === 0) {
      return false;
    }
    const termKey = searchTerm ?? '';
    if (termKey === this._lastFired1054Term) {
      return false;
    }
    this._lastFired1054Term = termKey;
    return true;
  }

  // 506 fires instead of 1054, never alongside it: skipped for a term 1054
  // already reported, and deduped per term+errorType so retries that fail
  // the same way don't re-report.
  shouldFire506(searchTerm, errorType) {
    if (!searchTerm || searchTerm === this._lastFired1054Term) {
      return false;
    }
    const key = `${searchTerm}|${errorType}`;
    if (key === this._lastFired506Key) {
      return false;
    }
    this._lastFired506Key = key;
    return true;
  }
  reset() {
    this._lastFiredSearchTerm = undefined;
    this._lastFired1053Term = undefined;
    this._lastFired1054Term = undefined;
    this._lastFired506Key = undefined;
  }
}
export const gateBiDedupService = new GateBiDedupService();
//# sourceMappingURL=gateBiDedupService.js.map